import { render, staticRenderFns } from "./BookingRowDetails.vue?vue&type=template&id=214af881"
import script from "./BookingRowDetails.vue?vue&type=script&lang=ts"
export * from "./BookingRowDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports